import { render, staticRenderFns } from "./SubscriptionBtn.vue?vue&type=template&id=f5143672&"
import script from "./SubscriptionBtn.vue?vue&type=script&lang=js&"
export * from "./SubscriptionBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports